class GijsplorerBeeper
  constructor: (waveForm, freq, @ctx) ->
    @carrier       = @ctx.createOscillator()
    @modulator     = @ctx.createOscillator()
    @carrierGain   = @ctx.createGain()
    @modulatorGain = @ctx.createGain()
    @master        = @ctx.createGain()

    @carrier.frequency.value   = freq
    @carrier.type              = waveForm
    @carrierGain.gain.value    = 0.1
    @modulator.frequency.value = 1
    @modulator.type            = 'sine'
    @modulatorGain.gain.value  = 0.1

    @carrier.connect(@carrierGain)
    @modulator.connect(@modulatorGain)
    @modulatorGain.connect(@carrierGain.gain)
    @carrierGain.connect(@master)
    @

  start: ->
    @carrier.start(0)
    @modulator.start(0)
    @

  stop: ->
    @master.gain.value = 0
    @ctx.suspend()
    @

  play: ->
    @master.connect(@ctx.destination)
    @ctx.resume()
    @

  update: (intensity, gainDivider) ->
    @modulator.frequency.value = intensity
    @master.gain.value         = intensity / gainDivider
    @modulator.frequency.cancelScheduledValues(0)
    @modulator.frequency.setValueAtTime(intensity, @ctx.currentTime)
    @

class GijsplorerSounds

  constructor: ->
    AudioContext = window.AudioContext || window.webkitAudioContext

    @audioContext = new AudioContext()

    @monsterBeeper = new GijsplorerBeeper('square', 100, @audioContext).start()
    @targetBeeper = new GijsplorerBeeper('sine', 500, @audioContext).start()

  playMonsterBeep: ->
    @monsterBeeper.play()

  playTargetBeep: ->
    @targetBeeper.play()

  stopMonsterBeep: ->
    @monsterBeeper.stop()

  stopTargetBeep: ->
    @targetBeeper.stop()

  monsterBeeps: (intensity) ->
    @monsterBeeper.update(
      Math.max((intensity * 2) ** 3, 0.1),
      20
    )

  targetBeeps: (intensity) ->
    @targetBeeper.update(
      Math.max((intensity * 2) ** 3, 0.1),
      5
    )

export default new GijsplorerSounds()
